import { useResponsiveness } from "@hooks/useResponsiveness";
import { Drawer as AntDrawer } from "antd";

export default function Drawer({
  open,
  onClose,
  children,
  className = "",
  placement = "right",
  width,
}) {
  const { sm } = useResponsiveness();
  return (
    <AntDrawer
      className={className || "!bg-secondary-main sm:rounded-s-[10px]"}
      placement={placement}
      closable={false}
      onClose={onClose}
      open={open}
      width={width ? width : sm ? 474 : "100%"}
    >
      {children}
    </AntDrawer>
  );
}
